import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, useMediaQuery } from '@material-ui/core';
import './Benefits2.scss';

const useStyles = makeStyles({
  principalGrid: {
    padding: '52px 42px 0',
    flexWrap: 'nowrap',
    '@media screen and (max-width: 1219.98px)': {
      display: 'flex',
      justifyContent: 'center',
      padding: '52px 42px 96px',
    },
    '@media screen and (max-width: 560.98px)': {
      padding: '52px 0 96px',
    }
  },
  squareGrid: {
    '@media screen and (max-width: 1219.98px)': {
      display: 'flex',
      justifyContent: 'center',
    }
  }
})

const Square = ({ corner, icon, text }) => {
  return (
    <div
      className='Benefits2_containerObject'
      style={{ backgroundImage: `url(${corner})` }}
    >
      <img
        src={icon}
        className='Benefits2_icon'
        alt='benefit'
      />
      <p className='Benefits2_text'>
        {text}
      </p>
    </div>
  )
}

const Benefits = (props) => {

  const classes = useStyles()
  const isMobile = useMediaQuery('(max-width: 768.98px)');
  const data = [
    {
      icon: '/img/Landing2/Benefits/Desktop/one.svg',
      corner: `/img/Landing2/Benefits/${!isMobile ? 'Desktop' : 'Mobile'}/corner1.svg`,
      text: 'Incrementa la posibilidad de obtener más clientes potenciales.',
      id: 1
    },
    {
      icon: '/img/Landing2/Benefits/Desktop/two.svg',
      corner: `/img/Landing2/Benefits/${!isMobile ? 'Desktop' : 'Mobile'}/corner2.svg`,
      text: 'Incrementa tus clientes potenciales desde tu celular o computadora.',
      id: 2
    },
    {
      icon: '/img/Landing2/Benefits/Desktop/three.svg',
      corner: `/img/Landing2/Benefits/${!isMobile ? 'Desktop' : 'Mobile'}/corner3.svg`,
      text: 'Acceso a reportes de tu perfil en tiempo real.',
      id: 3
    },
    {
      icon: '/img/Landing2/Benefits/Desktop/four.svg',
      corner: `/img/Landing2/Benefits/${!isMobile ? 'Desktop' : 'Mobile'}/corner4.svg`,
      text: 'Recibe notificaciones de clientes potenciales.',
      id: 4
    },
  ]

  return (
    <section className="Benefits2">
      <Grid
        container
        direction='row'
        classes={{ root: classes.principalGrid }}
      >
        <div className='Benefits2_containerLawyerImage'>
          <img
            src='/img/Landing2/Benefits/Desktop/lawyer.png'
            className='Benefits2_lawyerImage'
            alt='lawyer'
          />
        </div>
        <div className='Benefits2_containerSquareGrid'>
          <p className='Benefits2_title'>Beneficios de la plataforma</p>
          <Grid container classes={{ root: classes.squareGrid }}>
            {data && data.map(elem => 
              <Square
                corner={elem.corner}
                icon={elem.icon}
                text={elem.text}
                key={elem.id}
              />
            )}
          </Grid>
        </div>
      </Grid>
    </section>
  );
}

export default Benefits;
